import { useContext } from "react";
import { ToolContext } from "../../../../../core/context/ToolContext";
import { JoyrideWrapper } from "../JoyrideWrapper";

export const CallRecording = ({ end }) => {

	const {personalization_state} = useContext(ToolContext)
	const {walkthrough, startHere} = personalization_state

	const endTour = ()=>{
		walkthrough.set((p) => ({ ...p, callRecording: false}))
		startHere.set((p) => ({ ...p, show: true}))
	}

	const steps = [
		{
			target: '.callFirstStep',
			title: "First Call Record",
			content: 'Create your first call record.',
			disableBeacon: true,
			placement: "left",
		},
		{
			target: '.callSecondStep',
			title: "Select Offer Type",
			content: 'Provide your offer type for the client.',
			disableBeacon: true,
			placement: "bottom",
			path: '/campaign/call-monitoring?type=record&method=create'
		},
		{
			target: '.callThirdStep',
			title: "Fill-in Main Details",
			content: 'Save important details of the client.',
			disableBeacon: true,
			placement: "top"
		},
		{
			target: '.callFourthStep',
			title: "Time Details of Calls",
			content: 'Save important details for the calls.',
			disableBeacon: true,
			placement: "top"
		},
		{
			target: '.callFifthStep',
			title: "Cancel Transactions",
			content: "Cancel what you've input.",
			disableBeacon: true,
			placement: "top"
		},
		{
			target: '.callSixthStep',
			title: "Save Call Records",
			content: "Save your call records for the client.",
			disableBeacon: true,
			placement: "top"
		},
	]

	return (
		<JoyrideWrapper 
			run={Boolean(walkthrough.data.callRecording)} 
			steps={steps} 
			setter={endTour} 
			end={end}
			p_name="callRecording" 
			featureName="campaign"
		/>
	);
}
